import { useId, useLayoutEffect } from 'react';
import { useResolvedPath } from 'react-router-dom';

import { useIsShellHosted, useShell, useShellPage } from 'lib/context/ShellContext/ShellContext';

/**
 * `chrome` must be memoized by the caller.
 *
 * @param {object|null} chrome
 * @returns {{ isHosted: boolean }}
 */
export const usePageChrome = (chrome) => {
  const shell = useShell();
  const inPage = useShellPage();
  const isHosted = useIsShellHosted();
  const id = useId();
  const { pathname } = useResolvedPath('.');
  const register = inPage ? shell?.register : null;
  const unregister = inPage ? shell?.unregister : null;

  useLayoutEffect(() => {
    if (!register || !unregister || !chrome) return undefined;
    register(id, pathname.length, chrome);
    return () => unregister(id);
  }, [register, unregister, id, pathname, chrome]);

  return { isHosted };
};

export default usePageChrome;
